<template>
  <div id="app">

    <TheEntry />
    
    <!-- <router-view /> -->
    
  </div>
</template>

<script>
import TheEntry from './views/TheEntry'

export default {
  name: 'app',
  components: {
    TheEntry
  }
}
</script>

<style lang="sass">

@import './assets/css/main.css';

#app
  font-family: 'Megrim', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  position: relative
  width: 100vw
  height: 100vh
  overflow: hidden
  user-select: none
</style>
